import { DefineComponentProps } from 'utils'
import { CloseIcon } from '../icons/CloseIcon'
import { DialogHeaderLayout } from '../styles/dialog'
import type { CSSProperties } from 'vue'

type DialogHeaderProps = {
  onClose?: () => void
  showClose?: boolean
  height?: number
  style?: CSSProperties
  closeIconFill?: string
}

export const DialogHeader = defineComponent<DialogHeaderProps>({
  name: 'DialogHeader',
  props: DefineComponentProps<DialogHeaderProps>(['onClose', 'showClose', 'height', 'style', 'closeIconFill']),
  setup(props, { slots }) {
    const { showClose = true } = props
    return () => (
      <DialogHeaderLayout style={{ height: `${props.height || 44}px`, ...(props.style || {}) }}>
        <div class="custom-dialog-auth-header">
          <div class="custom-dialog-auth-header-title">{slots.default?.()}</div>
          {showClose && <CloseIcon class={'close-icon'} onClick={props.onClose} fill={props.closeIconFill} />}
        </div>
      </DialogHeaderLayout>
    )
  },
})
